package com.essntl.uikit.components.chat.contact

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ContactAvatar(
    initials: String?,
    isOnline: Boolean = false,
) {
    Box {
        // Avatar
        Box(
            contentAlignment = Alignment.Center,
            modifier = Modifier
                .size(40.dp)
                .border(
                    width = 1.dp,
                    color = Color(0xFF3a88fe),
                    shape = CircleShape,
                )
                .clip(CircleShape),
        ) {
            if (initials != null)
                Text(
                    text = initials,
                    color = Color(0xFF3a88fe),
                    style = MaterialTheme.esTypography.p2Medium14,
                    maxLines = 1,
                )
            else
                EsLargeIcon(
                    res = EsIcons.UserAvatar,
                    tint = Color(0xFF3a88fe)
                )
        }

        if (isOnline)
        // Online Dot
            Box(
                modifier = Modifier
                    .size(16.dp)
                    .clip(CircleShape)
                    .background(Color.White)
                    .padding(4.dp)
                    .clip(CircleShape)
                    .background(MaterialTheme.esColorScheme.iconSuccess)
                    .align(Alignment.BottomEnd),
            )
    }
}